const initialState = {
    get: [], 
    chat:[],
    docdata:[],
    viewdoc:[],
    uploaddoc:[],
    patient:[],
    
    
  
  };
  
  const DoctorViewCaseReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_DATA1_SUCCESS':
            return {... state, get:action.payload};
            case 'FETCH_DATA2_SUCCESS':
            return {... state, chat:action.payload};
            case 'FETCH_DATA3_SUCCESS':
            return {... state, docdata:action.payload};
            case 'FETCH_VIEW_SUCCESS':
            return {... state, viewdoc:action.payload};
            case 'FETCH_DOC_SUCCESS':
            return {... state, uploaddoc:action.payload};
            case 'FETCH_PAT_SUCCESS':
            return {... state, patient:action.payload};
            
            
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default DoctorViewCaseReducers;
  
  